export default __webpack_public_path__ + "static/media/Zain-Only-Txt.4ca96fbc.svg";